module.exports = __webpack_public_path__ + "img/lootbox-legendary-5.2d2bd8ac.jpg";